var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "report-box-new" }, [
    _c(
      "div",
      { class: ["flex-row", "box-header", _vm.isNewUi ? "blue-bg" : ""] },
      [
        _c(
          "div",
          { staticClass: "flex-col flex-10 justify-center" },
          [_vm._t("title")],
          2
        ),
        _vm.isNewUi
          ? _c(
              "div",
              {
                staticClass: "flex-col flex-2 justify-center align-end action",
              },
              [
                _c("font-awesome-icon", {
                  attrs: {
                    icon: [
                      "fas",
                      _vm.isExpanded ? "compress-alt" : "expand-alt",
                    ],
                    title: "expand",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.expandClicked()
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        !_vm.isNewUi
          ? _c(
              "div",
              {
                staticClass: "flex-col flex-2 justify-center align-end action",
              },
              [_vm._t("action")],
              2
            )
          : _vm._e(),
      ]
    ),
    _c("div", { staticClass: "flex-row report-box-content" }, [
      _c("div", { staticClass: "flex-col flex-1" }, [_vm._t("content")], 2),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }